module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "礼品卡制作",
      "visible": _vm.dialogVisible,
      "width": "50%",
      "close-on-click-modal": false,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.formInfo,
      "rules": _vm.formRules,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主题",
      "prop": "topicName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.topicName),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "topicName", $$v)
      },
      expression: "formInfo.topicName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片名称",
      "prop": "cardName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.cardName),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "cardName", $$v)
      },
      expression: "formInfo.cardName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片封面",
      "prop": "topicCover"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "accept": _vm.acceptImage,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "on-success": _vm.handlePictureCardPreview,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "祝福语",
      "prop": "blessingWords"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255",
      "show-word-limit": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.blessingWords),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "blessingWords", $$v)
      },
      expression: "formInfo.blessingWords"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片面值",
      "prop": "amount"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "min": 0,
      "placeholder": "请输入卡片面值",
      "controls-position": "right"
    },
    model: {
      value: (_vm.formInfo.amount),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "amount", $$v)
      },
      expression: "formInfo.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "卡片类型",
      "prop": "cardType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择卡片类型"
    },
    model: {
      value: (_vm.formInfo.cardType),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "cardType", $$v)
      },
      expression: "formInfo.cardType"
    }
  }, _vm._l((_vm.dataSource.cardTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期类型",
      "prop": "validType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择有效期类型"
    },
    model: {
      value: (_vm.formInfo.validType),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "validType", $$v)
      },
      expression: "formInfo.validType"
    }
  }, _vm._l((_vm.dataSource.validTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期",
      "prop": "validValue"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.validValue),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "validValue", $$v)
      },
      expression: "formInfo.validValue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.formInfo.status),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "status", $$v)
      },
      expression: "formInfo.status"
    }
  }, _vm._l((_vm.dataSource.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255",
      "show-word-limit": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "remark", $$v)
      },
      expression: "formInfo.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "使用说明:"
    }
  }, [_c('div', {
    attrs: {
      "id": "editor"
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dataFormSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-9b0be062","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/giftCard/components/edit.vue
// module id = 1737
// module chunks = 0